import { render } from "./bankPosModel.vue?vue&type=template&id=3846f534"
import script from "./bankPosModel.vue?vue&type=script&lang=js"
export * from "./bankPosModel.vue?vue&type=script&lang=js"

import "./bankPosModel.vue?vue&type=style&index=0&id=3846f534&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__